import {SimpleSignboard} from "./SimpleSignboardDTO";

type Bucket = {
  bucketKey: string,
  sortOrder: number,
}

type LogoUrl = {
  "type": "logoImg",
  "url": string,
  "urlReplaceStyle": "direct",
  "name": string
}
type ReturnUrl = {
  "type": "signupReturnUrl",
  "url": string,
  "urlReplaceStyle": "direct" | "cms",
  "name": string
}

export interface Signboard extends SimpleSignboard {
  urlList: (LogoUrl | ReturnUrl)[]
}

export class SignboardDTO implements Signboard {
  signboardId: number | null;
  signupKey: string;
  signupName: string;
  note: string;
  bucketList: Bucket[];
  urlList: (LogoUrl | ReturnUrl)[];

  constructor(
    signboardId: number | null,
    signupKey: string,
    signupName: string,
    note: string,
    bucketList: Bucket[],
    urlList: (LogoUrl | ReturnUrl)[],
  ) {
    this.signboardId = signboardId;
    this.signupKey = signupKey;
    this.signupName = signupName;
    this.note = note;
    this.bucketList = bucketList;
    this.urlList = urlList;
  }

  static fromJSON(jsonObject: Signboard): SignboardDTO {
    return new SignboardDTO(
      jsonObject.signboardId,
      jsonObject.signupKey,
      jsonObject.signupName,
      jsonObject.note,
      jsonObject.bucketList,
      jsonObject.urlList,
    )
  }
}
